import "date-fns";
import { useEffect, useState } from "react";
import {
  Input,
  InputLabel,
  InputAdornment,
  FormControl,
  FormGroup,
  Select,
  MenuItem,
  Snackbar,
  CircularProgress,
  Popover,
  Typography,
} from "@material-ui/core";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import {
  Col,
  Row,
  Button,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { useFlightData } from "../../data/FlightData";
import City from "../City";
import airportData from "../../data/airport";
import { useLocalStorage } from "../../utils/useLocalStorage";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import LoginAndSignUp from "../LoginAndSignUp";
import SwapImage from "../../assets/images/icons/swap.png";
import { FaTimes } from "react-icons/fa";
import * as React from "react";
import HelpIcon from "@mui/icons-material/Help";
import { useHistory } from "react-router-dom";
import PlansPopup from "../../pages/PlansPopup";

function Search({
  unregistedFlightsData,
  setFlightData,
  fromAirport,
  toAirport,
}) {
  const currentDate = new Date();
  const {
    AllUnregFlights,
    UnregSearchFlights,
    searchFlights,
    searchFlyEasyFlights,
    allRegFlights,
    addFlight,
    FlightPrice,
  } = useFlightData();

  const [from, setFrom] = useState(fromAirport);
  const [to, setTo] = useState(toAirport);
  const [datevalue, setDateValue] = useState(null);
  const [formatteddatevalue, setFormattedDateValue] = useState(null);
  const [passenger, setPassenger] = useState("0");
  const [pettype, SetPetType] = useState("No");
  const [friend, setFriend] = useState("No");
  const [isSearchClick, setIsSearchClick] = useState(false);
  const [user] = useLocalStorage("auth", {});
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isFlightAdded, setFlightAdded] = useState(false);
  const [isPricePosted, setPricePosted] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);
  const [modal, setModal] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [isSearchedOnce, setSearchedOnce] = useState(false);
  const handleClosePopup = () => setShowPopup(false);
  const handleShowPopup = () => setShowPopup(true);
  let history = useHistory();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  // Toggle for Modal
  const toggle = () => setModal(!modal);

  const ResetSearch = () => {
    history.push("/");
    //Reset search fields
    //setFrom(user.home_code || 'NYALL');
    //setTo(null);
    // setDateValue(null);
    // setPassenger("0");
    // setIsPrivate(false);

    // //Fetch default flights
    // if (typeof user.userid === "undefined") {
    //   GetUnregisteredFlights().then((data) => {
    //     setFlightData(data);
    //   });
    // } else {
    //   GetRegFlights(user.userid).then((data) => {
    //     setFlightData(data);
    //   });
    // }
  };

  async function convertFlightData(jsonData) {
    //const data = jsonData[0]; // get the first element from the provided array
    console.log(jsonData);
    try {
      for (var i in jsonData) {
        let data = jsonData[i];
        const id = Math.floor(Math.random() * 90000) + 10000;
        const flyeasy_id = data._id;
        const userid = 55;
        var dep_date = data.date; //new Date(data.date).toLocaleDateString(); // extract the departure date and format it
        var dep_time;
        //const dep_time = data.flightTimeStr;//new Date(data.date1).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }); // extract the departure time and format it
        const plane_type = data.ac.title; // get the plane type from the provided data
        const from_city = data.airportFrom.city.toUpperCase(); // get the origin city and convert it to uppercase
        const to_city = data.airportTo.city.toUpperCase(); // get the destination city and convert it to uppercase
        const from_airport = data.airportFrom.iata; // get the origin airport code
        const to_airport = data.airportTo.iata; // get the destination airport code
        const total_seats = null; // no total seats provided in the original data
        const available_seats = data.ac.pax; // get the number of available seats from the provided data
        var total_price = Math.round(data.price); // convert the price to cents and round it
        const isflexible = false;
        const passenger = null;
        const is_pet = null;
        const pet_type = null;
        const is_posted = true;
        const name = "Katana";
        const flyxo_bookingurl = null;
        const isfriend = true;
        const isgroup = false;
        const departure_date = data.date1; // get the departure date and time in ISO format
        const profile_pic_path =
          require("../../assets/images/CharterDefaultIMage.jpg").default;
        const group_profile_pic_path = "";
        const group_name = null;
        const is_private = false;
        const inquiries = 0;
        const is_charter = true;
        const subscription_plan = 1;

        if (dep_date.includes("-")) {
          const parts = dep_date.split("-");
          dep_date = [parts[1], parts[2], parts[0].substring(2, 4)].join("/");
        } else {
          const parts = dep_date.split("/");
          dep_date = [parts[0], parts[1], parts[2].substring(2, 4)].join("/");
        }

        //if(total_price == 0) total_price = "Upon Request";
        jsonData[i] = {
          id,
          flyeasy_id,
          userid,
          dep_date,
          dep_time,
          plane_type,
          from_city,
          to_city,
          from_airport,
          to_airport,
          total_seats,
          available_seats,
          total_price,
          isflexible,
          passenger,
          is_pet,
          pet_type,
          is_posted,
          name,
          flyxo_bookingurl,
          isfriend,
          isgroup,
          departure_date,
          profile_pic_path,
          group_profile_pic_path,
          group_name,
          is_private,
          inquiries,
          is_charter,
          subscription_plan,
        };
      }

      console.log(jsonData);

      return jsonData;
    } catch (err) {
      console.log("Conversion Err: " + err);
    }
  }

  async function convertFlightDataForDate(arr) {
    //const data = jsonData[0]; // get the first element from the provided array
    console.log(arr);
    try {
      let resultArr = [];
      let obj = arr;
      for (var i in obj) {
        const date1 = obj[i].date1.substring(0, 10);

        const date2 = obj[i].date2.substring(0, 10);

        if (date1 !== date2) {
          let startDate = new Date(date1);
          startDate.setHours(0, 0, 0, 0);
          const endDate = new Date(date2);
          endDate.setHours(0, 0, 0, 0);
          console.log("Start date: " + startDate);
          console.log("End date: " + endDate);
          while (startDate <= endDate) {
            console.log("Date: " + startDate);
            console.log("Obj: " + obj[i].date1);
            var formattedDate = startDate.toLocaleDateString().slice(0, 10);
            resultArr.push({ date: formattedDate, ...obj[i] });
            startDate.setDate(startDate.getDate() + 1);
          }
        } else {
          resultArr.push({ date: date1, ...obj[i] });
        }
      }
      console.log("Date formatted: " + resultArr);

      return resultArr;

      //return jsonData;
    } catch (err) {
      console.log("Conversion Err: " + err);
    }
  }

  const GetSearchFlightDetails = async () => {
    let postData = {
      dep_date: formatteddatevalue,
      from_city: getCityFromCode(from),
      from_airport: from,
      to_city: getCityFromCode(to),
      to_airport: to,
      passenger: parseInt(passenger === "" ? "0" : passenger),
      is_pet: pettype === "No" ? false : true,
      pet_type: pettype,
    };

    if (typeof user.userid !== "undefined") {
      postData.userid = parseInt(user.userid);
      postData.is_friend = friend === "No" ? false : true;
      postData.is_private = isPrivate;
    }
    let flights;
    if (typeof user.userid === "undefined") {
      flights = await UnregSearchFlights(postData);
    } else {
      flights = await searchFlights(postData);
    }
    let flyeasy_flights;
    //ALI 1-2-2024 FLYEASY WORKS NOW WITH ONLY FROM CITY
    //if (postData.to_city) {
    if (postData.from_city) {
      postData.from_icao = getICAOFromIATA(from);
      postData.to_icao = getICAOFromIATA(to);
      flyeasy_flights = await searchFlyEasyFlights(postData);
      let fl_flights = flyeasy_flights.flights;
      console.log("FlyEasy RAW: " + fl_flights);
      if (fl_flights.length > 0) {
        fl_flights = await convertFlightDataForDate(fl_flights);
        fl_flights = await convertFlightData(fl_flights);
        //console.log("FlyEasy flights: "+JSON.stringify(flyeasy_flights.flights));
        flights.push(...fl_flights);

        //Sort based on date and time
        flights = flights.sort((a, b) => {
          if (a.dep_date) {
            const aTimestamp = new Date(`${a.dep_date}`).getTime();
            const bTimestamp = new Date(`${b.dep_date}`).getTime();
            //console.log(aTimestamp);
            return aTimestamp - bTimestamp;
          }
          return 0;
        });
        //console.log("Sorted flights: "+JSON.stringify(flights));
      }
    }
    return flights;
  };

  useEffect(() => {
    if (typeof user.userid === "undefined") {
      GetUnregisteredFlights().then((data) => {
        setFlightData(data);
      });
    } else {
      //console.log(user);
      //setFrom(user.home_code || 'NYALL');
      GetRegFlights(user.userid).then((data) => {
        setFlightData(data);
      });
    }
  }, []);

  useEffect(() => {
    if (true) {
      GetSearchFlightDetails().then((data) => {
        setFlightData(data);
      });
    }
  }, [pettype]);

  function getFormatedDate(strDate) {
    let date = new Date(strDate);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();
    if (dt < 10) {
      dt = "0" + dt;
    }
    if (month < 10) {
      month = "0" + month;
    }
    return month + "/" + dt + "/" + year;
  }

  function getCityFromCode(code) {
    if (code) return airportData.find((item) => item.IATA === code).city;
    else return null;
  }

  function getICAOFromIATA(iata) {
    if (iata)
      return airportData.find((item) => item.IATA === iata).icao_code || iata;
    else return iata;
  }

  const GetUnregisteredFlights = async () => {
    return await AllUnregFlights();
  };

  const GetRegFlights = async (userid) => {
    return await allRegFlights(userid);
  };

  const DateChange = (date) => {
    setFormattedDateValue(getFormatedDate(date));
    setDateValue(date);
  };

  function SearchUnregisterData(event) {
    if (from == "" || from == undefined || from == null) {
      setErrorMessage("Please select from");
      setIsError(true);
    } else {
      setIsSearchClick(true);
      setSearchedOnce(true);
      GetSearchFlightDetails().then((data) => {
        setFlightData(data);
      });
    }
  }

  function SwapCity(e) {
    console.log(to);
    if (to !== "" && to !== undefined && to !== null) {
      const From = from;
      setFrom(to);
      setTo(From);
    }
  }

  function ValidateData() {
    if (from === "" || from === undefined || from === null) {
      setErrorMessage("Please select from");
      setIsError(true);
      return false;
    } else if (to === "" || to === undefined || to === null) {
      setErrorMessage("Please select to");
      setIsError(true);
      return false;
    } else if (
      formatteddatevalue === "" ||
      formatteddatevalue === undefined ||
      formatteddatevalue === null
    ) {
      setErrorMessage("Please select valid date");
      setIsError(true);
      return false;
    } else if (
      passenger === "" ||
      passenger === undefined ||
      passenger === null ||
      passenger < 1
    ) {
      setErrorMessage("Please select passenger");
      setIsError(true);
      return false;
    } else {
      setErrorMessage("");
      setIsError(false);
      return true;
    }
  }

  async function AddFlightDetails(event) {
    if (user.subscription_plan_id == 2 || user.subscription_plan_id == 3) {
      if (ValidateData()) {
        const postData = {
          userid: user.userid,
          dep_date: formatteddatevalue,
          from_city: getCityFromCode(from),
          from_airport: from,
          to_city: getCityFromCode(to),
          to_airport: to,
          passenger: parseInt(passenger === "" ? "0" : passenger),
          is_pet: pettype === "No" ? false : true,
          pet_type: pettype,
          is_private: isPrivate,
        };
        const response = await addFlight(postData);
        if (response) {
          setFlightAdded(true);
          toggle(); //All Set popup
        }
      }
    } else {
      handleShowPopup();
      //history.push('/plans');
    }
  }

  async function BookFlightPrice(event) {
    if (ValidateData()) {
      const postData = {
        userid: user.userid,
        dep_date: formatteddatevalue,
        from_city: getCityFromCode(from),
        from_airport: from,
        to_city: getCityFromCode(to),
        to_airport: to,
        passenger: parseInt(passenger === "" ? "0" : passenger),
        is_pet: pettype === "No" ? false : true,
        pet_type: pettype,
        is_private: isPrivate,
      };
      const response = await FlightPrice(postData);
      console.log(response);
      if (response.status) {
        setPricePosted(true);
        toggle(); //All Set popup
      }
    }
  }

  return (
    <>
      {isError && (
        <Snackbar
          open={isError}
          autoHideDuration={3000}
          anchorOrigin={{ horizontal: "center", vertical: "top" }}
          onClose={(e) => setIsError(!isError)}
        >
          <Alert color="danger">{errorMessage}</Alert>
        </Snackbar>
      )}

      <PlansPopup show={showPopup} handleClose={handleClosePopup} />

      {isPricePosted && (
        <Snackbar
          open={isPricePosted}
          autoHideDuration={6000}
          anchorOrigin={{ horizontal: "center", vertical: "top" }}
          onClose={(e) => setPricePosted(!isPricePosted)}
        >
          <Alert className="alertYellowInverse">
            Katana will be in touch shortly
          </Alert>
        </Snackbar>
      )}

      {isFlightAdded && (
        <Snackbar
          open={isFlightAdded}
          autoHideDuration={3000}
          anchorOrigin={{ horizontal: "center", vertical: "top" }}
          onClose={(e) => setFlightAdded(!isFlightAdded)}
        >
          <Alert className="alertYellowInverse">All Set</Alert>
        </Snackbar>
      )}
      <Row className="pl-2 pr-1 mt-2">
        {/* From City */}
        <Col lg="3" md="3" sm="12" xs="12">
          <City type="from" code={from} setCode={setFrom} />
        </Col>

        {/* Swap icon */}
        <Col
          lg="1"
          md="1"
          sm="12"
          xs="12"
          className="d-flex justify-content-center align-items-center mt-3 mt-lg-0"
        >
          <img src={SwapImage} className="btnSwap" onClick={SwapCity} />
        </Col>

        {/* To City */}
        <Col lg="3" md="4" sm="16" xs="16">
          <City type="to" code={to} setCode={setTo} />
        </Col>

        {/* Date Picker */}
        <Col lg="3" md="3" sm="12" xs="12" className="mb-3">
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              className="p-0"
              fullWidth
              label="Date"
              minDate={new Date().toString()}
              format="MM/dd/yyyy"
              value={datevalue}
              onChange={DateChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              keyboardIcon={
                <img
                  alt="..."
                  style={{ height: "25px" }}
                  src={
                    require("../../assets/images/icons/calendar.png").default
                  }
                />
              }
            />
          </MuiPickersUtilsProvider>
          {datevalue && (
            <FaTimes
              style={{
                position: "absolute",
                bottom: "5px",
                right: "10px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                setDateValue(null);
                setFormattedDateValue(null);
              }}
            />
          )}
        </Col>
        {/* <Col lg="6" md="6" sm="6" xs="6">
          <FormGroup className="mb-3">
            <FormControl fullWidth>
              <InputLabel htmlFor="passengers">Passengers</InputLabel>
              <Select
                id="passengers"
                value={passenger}
                onChange={(e) => setPassenger(e.target.value)}
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      alt="..."
                      style={{ height: "25px" }}
                      src={
                        require("../../assets/images/icons/passengers.png")
                          .default
                      }
                    />
                  </InputAdornment>
                }
              >
                <MenuItem value={0}>Select</MenuItem>
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
                <MenuItem value={3}>3</MenuItem>
                <MenuItem value={4}>4</MenuItem>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={7}>7</MenuItem>
                <MenuItem value={8}>8</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={10}>10</MenuItem>
              </Select>
            </FormControl>
          </FormGroup>
        </Col>
        <Col lg="6" md="6" sm="6" xs="6" className="p-0">
          {typeof user.userid !== "undefined" && (
            <FormGroup>
              <FormControl>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: "20px",
                    justifyContent: "left",
                  }}
                >
                  <span>&nbsp;&nbsp;&nbsp;Public:&nbsp;</span>
                  <input
                    type="radio"
                    name="public"
                    value="Yes"
                    checked={!isPrivate}
                    onChange={(e) => setIsPrivate(false)}
                  ></input>
                  <span
                    onClick={(e) => setIsPrivate(false)}
                    style={{ cursor: "pointer", 'font-size':'14px' }}
                  >
                    Yes
                  </span>
                  &nbsp;&nbsp;
                  <input
                    type="radio"
                    name="public"
                    value="No"
                    checked={isPrivate}
                    onChange={(e) => setIsPrivate(true)}
                  ></input>
                  <span
                    onClick={(e) => setIsPrivate(true)}
                    style={{ cursor: "pointer", 'font-size':'14px' }}
                  >
                    No
                  </span>
                  <div style={{ 'padding-left': '2px'}}>
                <HelpIcon sx={{ fontSize: 16,  }}  aria-describedby={id} variant="contained" onClick={handleClick}>                
                </HelpIcon>
                <Popover
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                >
                  <Typography style={{background:"#FFE600"}}  sx={{ p: 2 }}>If Not Public (No) only Friends and Members of the same Group will be notified and see on site.</Typography>
                </Popover>
              </div>
                </div>                
              </FormControl>
            </FormGroup>
          )} */}
        {/* <FilterPet pet={pet} setPet={setPet} /> */}
        {/* <FormGroup className="mb-3">
            <FormControl fullWidth>
              <InputLabel htmlFor="pet">Pet</InputLabel>
              <Select
                id="pet"
                value={pettype}
                onChange={(e) =>
                  SetPetType(e.target.value == "" ? "No" : e.target.value)
                }
                startAdornment={
                  <InputAdornment position="start">
                    <img
                      alt="..."
                      style={{ height: "25px" }}
                      src={require("../../assets/images/icons/pet.png").default}
                    />
                  </InputAdornment>
                }
              >
                <MenuItem value="No">No</MenuItem>
                <MenuItem value="Cat">Cat</MenuItem>
                <MenuItem value="Dog">Dog</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </FormControl>
          </FormGroup> */}
        {/* </Col> */}

        {typeof user.userid !== "undefined" ? (
          <>
            <Col lg="2" md="2" sm="12" xs="12" className="p-1">
              <Button
                color="dark"
                className="btn btn-block btn btn-secondary btnYellow"
                onClick={SearchUnregisterData}
              >
                Search
              </Button>
            </Col>
            {/* <Col lg="4" md="4" sm="4" xs="4" className="p-1">
              <Button
                color="dark"
                className="btn btn-block btn btn-secondary btnYellow"
                onClick={ResetSearch}
              >
                Reset
              </Button>
            </Col> */}
            {isSearchedOnce && (
              <>
                <Col lg="6" md="6" sm="6" xs="6" className="p-1">
                  <Button
                    color="dark"
                    className="btn btn-block btn btn-secondary btnYellow"
                    onClick={AddFlightDetails}
                  >
                    Add Interest
                  </Button>
                </Col>
                <Col lg="6" md="6" sm="6" xs="6" className="p-1">
                  <Button
                    color="dark"
                    className="btn btn-block btn btn-secondary btnYellow"
                    onClick={BookFlightPrice}
                  >
                    Get Price
                  </Button>
                </Col>
              </>
            )}
            <Snackbar
              autoHideDuration={2000}
              toggle={toggle}
              color="dark"
              open={modal}
              onClose={toggle}
              anchorOrigin={{ horizontal: "center", vertical: "top" }}
              keyboard={false}
              style={{ height: "100%", width: "100%" }}
            >
              <Alert
                className="text-center"
                color="dark"
                style={{ color: "rgb(255, 230, 0)" }}
              >
                <CheckCircleOutlineIcon />
                <br />
                {"All Set"}
              </Alert>
            </Snackbar>
          </>
        ) : (
          <>
            <Col lg="2" md="2" sm="12" xs="12" className="p-1">
              <Button
                color="dark"
                className="btn btn-block btn btn-secondary btnYellow"
                onClick={SearchUnregisterData}
              >
                Search
              </Button>
            </Col>
            {/* <Col lg="4" md="4" sm="4" xs="4" className="p-1">
              <Button
                color="dark"
                className="btn btn-block btn btn-secondary btnYellow"
                onClick={ResetSearch}
              >
                Reset
              </Button>
            </Col> */}
            <Col lg="6" md="6" sm="6" xs="6" className="p-1">
              <LoginAndSignUp
                ButtonMode="AddFlight"
                isSearchedOnce={isSearchedOnce}
              />
            </Col>
            <Col lg="6" md="6" sm="6" xs="6" className="p-1">
              <LoginAndSignUp
                ButtonMode="GetPrice"
                isSearchedOnce={isSearchedOnce}
              />
            </Col>
          </>
        )}
      </Row>
    </>
  );
}

export default Search;
